import React, { useContext, useEffect, useMemo, useState } from 'react';
import './Config.css';
import { AppContext } from '../../../context/AppContext';
import { simpleGetCall, PostCallWithErrorResponse } from '../../../api/ApiServices';
import { Spinner } from 'react-bootstrap';
import { notifySuccess, notifyError } from '../../../toaster/notify';
import DeleteModal from '../../../sharedComponent/DeleteModal';
import Loader from '../../Loader';
import FallbackLogicBox from './FallbackLogicBox';
import StoreSelector from '../../StoreSelector';

const StoreConfig = () => {

  // -----------------------------
// ROUND OFF STATES
// -----------------------------
const [roundType, setRoundType] = useState("DOWNWARD"); // normal | up | down | none
const [increment, setIncrement] = useState(1);
const [decimalPoints, setDecimalPoints] = useState(2);



const sampleValue = 2.2;

  const [activeTab] = useState('delivery');
  const { sidebar, selectedStoreID,selectedRestID,ApiConfig, storesList, permissions, setSelectedStoreID} = useContext(AppContext);


  const [restaurantConfig, setRestaurantConfig] = useState({
    auto_accept : false,
  delivery_range_km: 6,
  minimum_order_amount: 250,
  order_cancelation_window_minutes: 2,
  payment_config: [
    { cod: true, type: "take-away", online: true },
    { cod: true, type: "delivery", online: true },
    { cod: true, type: "dine-in", online: false }
  ],
  delivery_config: {
    currency: "INR",
    surcharges: {
      late_night: {
        label: "Night Surge",
        enabled: false,
        end_time: "04:00",
        fee_amount: 40,
        start_time: "15:00",
        display_message: "Late night delivery surcharge applied"
      },
      small_cart: {
        enabled: false,
        threshold: 150,
        fee_amount: 30,
        display_message: "Add items worth INR{{diff}} more to remove this fee!"
      },
      cod_handling: {
        label: "Cash Handling Fee",
        enabled: false,
        fee_amount: 10,
        display_message: "Cash on Delivery handling fee applied",
        waived_if_cart_above: 500
      },
      festival_mode: {
        label: "Diwali Rush Fee",
        enabled: false,
        fee_amount: 25,
        display_message: "Festival season surcharge applied"
      }
    },
    delivery_taxes: [
      { id: 470, tax: "9", tax_name: "SGST", tax_type: 1 },
      { id: 471, tax: "9", tax_name: "CGST", tax_type: 1 }
    ],
    base_components: {
      base_fee: 0,
      distance_logic: {
        type: "RANGES",
        tiers: [
          { label: "Tier 1", max_km: 2, min_km: 0, flat_fee: 10 },
          { label: "Tier 2", max_km: 5, min_km: 2, flat_fee: 20 },
          { label: "Tier 3", max_km: 8, min_km: 5, flat_fee: 40 },
          { label: "Tier 4", max_km: 11, min_km: 8, flat_fee: 50 },
          { label: "Tier 5", max_km: 13, min_km: 11, flat_fee: 60 },
          { label: "Tier 6", max_km: 15, min_km: 13, flat_fee: 70 }
        ],
        fallback_logic: {
          description: "Applied if distance > max tier (9km)",
          base_fee_start: 50,
          additional_per_km: 10
        }
      }
    },
    pricing_engine_id: "india_metro_tiered_v2",
    calculation_strategy: "TIERED_STEP_FUNCTION",
    discounts_and_waivers: {
      happy_hours: [],
      acquisition_offers: [
        {
          benefit: { type: "FULL_DELIVERY_WAIVER", max_cap: 100 },
          rule_id: "FIRST_ORDER_FREE",
          condition: "USER_TOTAL_ORDERS == 0",
          marketing_text: "First order free delivery up to INR {{max_cap}}"
        }
      ],
      cart_value_discounts: [
        {
          benefit: {
            type: "WAIVE_TIER_COST",
            is_percentage: false,
            max_km_covered: 5
          },
          rule_id: "HIGH_VALUE_FREE_5KM",
          marketing_text:
            "Free delivery (first {{distance}}km) for orders > INR {{min_cart_value}}",
          min_cart_value: 500
        },
        {
          benefit: {
            type: "WAIVE_TIER_COST",
            is_percentage: false,
            max_km_covered: 10
          },
          rule_id: "PREMIUM_FREE_10KM",
          marketing_text:
            "Free delivery (first {{distance}}km) for orders > INR {{min_cart_value}}",
          min_cart_value: 750
        }
      ]
    },

 round_off_config :   {
    "method": "DOWNWARD",
    "increment": 1,
    "precision": 2
}
  },
  packing_config: {
    enabled: true,
    currency: "INR",
    packing_taxes: [
      { id: 470, tax: "2.5", tax_name: "SGST", tax_type: 1 },
      { id: 471, tax: "2.5", tax_name: "CGST", tax_type: 1 }
    ],
    package_charges: 25,
    pricing_engine_id: "india_metro_tiered_v2",
    calculation_strategy: "FLAT_CALCULATION_STRATEGY",
    package_exemption_price: 500
  }
});



// -----------------------------
// ROUNDING LOGIC
// -----------------------------
const roundedValue = useMemo(() => {
  let value = sampleValue;

  if (restaurantConfig?.round_off_config?.method === "NONE") {
    return value.toFixed(restaurantConfig?.round_off_config?.precision);
  }

  const factor = 1 / restaurantConfig?.round_off_config?.increment;

  if (restaurantConfig?.round_off_config?.method === "UPWARD") {
    value = Math.ceil(value * factor) / factor;
  } else if (restaurantConfig?.round_off_config?.method === "DOWNWARD") {
    value = Math.floor(value * factor) / factor;
  } else {
    value = Math.round(value * factor) / factor;
  }

  return value.toFixed(restaurantConfig?.round_off_config?.precision);
}, [restaurantConfig?.round_off_config, decimalPoints]);
  const [loading, setLoading] = useState(false);

  const [showDeleteModalForTier, setShowDeleteModalForTier] = useState(false);
  const [showDeleteModalForWaiver, setShowDeleteModalForWaiver] = useState(false);
  const [showDeleteModalForHappyHour, setShowDeleteModalForHappyHour] = useState(false);
  const [deleteID, setDeleteID] = useState(null);


   const filterRestaurantName = (resId = null, storesList = []) => {
   
    if(resId) {
    const item = storesList?.filter((item)=> item.value == resId );
  
    return item?.[0]?.label;
    }
   }

   const resId = restaurantConfig?.restaurant_id ?? selectedStoreID ?? null; 

  const handleOpenDeleteModal = (idx, type) => {
    setDeleteID(idx);
    if(type === 'tier') {
    setShowDeleteModalForTier(true);
    } else if (type === 'happy') {
      setShowDeleteModalForHappyHour(true);
    }

    else  {
      setShowDeleteModalForWaiver(true);
    }
  }

  const handleCloseDeleteModal = (type) => {
    if(type === 'tier'){
setShowDeleteModalForTier(false);
    } else if (type === 'happy') {
      setShowDeleteModalForHappyHour(false);
    }
    
    else {
      setShowDeleteModalForWaiver(false);
    }

    
  }

 


   const getRestaurantConfig = async () => {
      setLoading(true);
  
      try {
        const res = await simpleGetCall(
          ` ${ApiConfig?.POST_RESTAURANT_CONFIG(selectedStoreID)}`
        );
  
        const itemlist = res.data;
        if (res.success) {
          setRestaurantConfig(itemlist);
        
        } else {
      
        }
      } catch (err) {
        console.error("Status API Error:", err);
      } finally  {
        setLoading(false);
      }
    };
    useEffect(()=>{
      if(selectedStoreID){
      getRestaurantConfig();
      }
    },[selectedStoreID])




    // Generic input handler
  const handleInputChange = (field, value) => {
    setRestaurantConfig((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  // Nested object handler (e.g., delivery_config, packing_config)
  // const handleNestedChange = (path, value) => {
  //   setRestaurantConfig((prev) => {
  //     const updated = { ...prev };
  //     let current = updated;
  //     path?.forEach((key, index) => {
  //       if (index === path?.length - 1) {
  //         current[key] = value;
  //       } else {
  //         current[key] = { ...current[key] };
  //         current = current[key];
  //       }
  //     });
  //     return updated;
  //   });
  // };


  const handleNestedChange = (path, value) => {
  setRestaurantConfig(prev => {
    const updated = structuredClone(prev); // keeps arrays properly
    let current = updated;

    path.forEach((key, index) => {
      if (index === path.length - 1) {
        current[key] = value;
      } else {
        // If next level is array → clone as array
        if (Array.isArray(current[key])) {
          current[key] = [...current[key]];
        } 
        // If next level is object → clone as object
        else {
          current[key] = { ...current[key] };
        }
        current = current[key];
      }
    });

    return updated;
  });
};


  // Example: handle payment config change
  const handlePaymentChange = (index, field, value) => {
    setRestaurantConfig((prev) => {
      const updated = { ...prev };
      updated.payment_config = [...prev.payment_config];
      updated.payment_config[index] = { ...updated.payment_config[index], [field]: value };
      return updated;
    });
  };

  // Example: handle distance tier change
  const handleDistanceTierChange = (index, field, value) => {
    setRestaurantConfig((prev) => {
      const updated = { ...prev };
      const tiers = [...updated.delivery_config.base_components.distance_logic.tiers];
      tiers[index] = { ...tiers[index], [field]: value };
      updated.delivery_config.base_components.distance_logic.tiers = tiers;
      return updated;
    });
  };

  const handleAddTier = () => {
  setRestaurantConfig((prev) => {
    const updated = { ...prev };
    const tiers = [...updated.delivery_config.base_components.distance_logic.tiers];

    // Add a new empty tier
    tiers.push({
      label: '',
      min_km: '',
      max_km: '',
      flat_fee: '',
    });

    updated.delivery_config.base_components.distance_logic.tiers = tiers;
    return updated;
  });
};


const handleDeleteTier = (index) => {
  setRestaurantConfig((prev) => {
    const updated = { ...prev };
    const tiers = [...updated.delivery_config.base_components.distance_logic.tiers];
    tiers.splice(index, 1); // remove the tier at index
    updated.delivery_config.base_components.distance_logic.tiers = tiers;
    return updated;
  });
};

  const [postLoading, setPostLoading] = useState(false);
  // Save changes


  function validateDistanceTiers(tiers) {
 
  for (const tier of tiers) {
    const min = Number(tier.min_km);
    const max = Number(tier.max_km);

    if (isNaN(min) || isNaN(max)) {
      notifyError(`${tier.label} has invalid numeric values`);
      return false;
    }

    if (max <= min) {
      notifyError(`${tier.label} range is invalid`);
      return false;
    }
  }

  return true;
}
  const handleSave = async () => {
    setPostLoading(true);
    const isValid = validateDistanceTiers(restaurantConfig?.delivery_config?.base_components?.distance_logic?.tiers)
    if(!isValid) {
      setPostLoading(false);
      return

    }
   



    try {
      const res = await PostCallWithErrorResponse(ApiConfig?.POST_RESTAURANT_CONFIG(selectedStoreID), JSON.stringify(restaurantConfig));
    
      if (res.json.success) {
        notifySuccess(res.json.message);
        getRestaurantConfig();
       
      } else {
        notifyError(res.json.message)
      }
    } catch (err) {
      console.error('Error saving config:', err);
      if(!selectedRestID){
        notifyError("Please select restaurant.")
      } else{
      notifyError("Something went wrong.")
      }
    } finally {
      setPostLoading(false);
    }
  };




   // --- NEW HANDLERS FOR SURCHARGES AND DISCOUNTS ---

  // Toggle surcharge enabled/disabled
  const handleSurchargeToggle = (key) => {
    handleNestedChange(['delivery_config', 'surcharges', key, 'enabled'], 
      !restaurantConfig.delivery_config.surcharges[key].enabled
    );
  };

  // Update surcharge fee or threshold
  const handleSurchargeChange = (key, field, value) => {
    handleNestedChange(['delivery_config', 'surcharges', key, field], value);
  };

  // Toggle happy hour discount
  const handleHappyHourToggle = (index) => {
    const updated = { ...restaurantConfig };
    updated.delivery_config.discounts_and_waivers.happy_hours[index].enabled =
      !updated.delivery_config.discounts_and_waivers.happy_hours[index].enabled;
    setRestaurantConfig(updated);
  };

  // Toggle acquisition offer
  const handleAcquisitionToggle = (index) => {
    const updated = { ...restaurantConfig };
    updated.delivery_config.discounts_and_waivers.acquisition_offers[index].enabled =
      !updated.delivery_config.discounts_and_waivers.acquisition_offers[index].enabled;
    setRestaurantConfig(updated);
  };

  // Update cart value waiver min_cart_value
  const handleCartValueChange = (index, value) => {
    const updated = { ...restaurantConfig };
    updated.delivery_config.discounts_and_waivers.cart_value_discounts[index].min_cart_value = value;
    setRestaurantConfig(updated);
  };
const [visibleCount, setVisibleCount] = useState(1); 
 
  const { surcharges = [], discounts_and_waivers = [] } = restaurantConfig?.delivery_config ?? {};
  



  if (!restaurantConfig) return <div>No configuration available</div>;


  const handleAddSurcharge = () => {
  const id = `custom_${Date.now()}`;

  const newSurcharge = {
    label: "Custom Surcharge",
    enabled: false,
    threshold: 0,
    fee_amount: 0,
    display_message: ""
  };

  setRestaurantConfig(prev => ({
    ...prev,
    delivery_config: {
      ...prev.delivery_config,
      surcharges: {
        ...prev.delivery_config.surcharges,
        [id]: newSurcharge
      }
    }
  }));
};



const handleDeleteSurcharge = (key) => {
  setRestaurantConfig(prev => {
    const updated = { ...prev };
    delete updated.delivery_config.surcharges[key];
    return updated;
  });
};



const surchargeOrder = Object.keys(
  restaurantConfig?.delivery_config?.surcharges ?? {}
);


const handleAddSurchargeClick = () => {
  if (visibleCount < surchargeOrder.length) {
    setVisibleCount(prev => prev + 1);
  } else {
    notifyError("You have added all the surcharges");
  }
};


const handleDeleteHappyHour = (index) => {
  const updated = [...restaurantConfig.delivery_config.discounts_and_waivers.happy_hours];
  updated.splice(index, 1);

  handleNestedChange(
    ['delivery_config', 'discounts_and_waivers', 'happy_hours'],
    updated
  );
};





const handleTypeChange = (index, value) => {
  setRestaurantConfig(prev => {
    const updated = { ...prev };
    updated.delivery_config.discounts_and_waivers.cart_value_discounts[index].benefit.type = value;
    return updated;
  });
};


const handlePercentageChange = (index, value) => {
  setRestaurantConfig(prev => {
    const updated = { ...prev };
    updated.delivery_config.discounts_and_waivers.cart_value_discounts[index].benefit.is_percentage =
      value === "YES";
    return updated;
  });
};


const handleBenefitChange = (index, value) => {
  setRestaurantConfig(prev => {
    const updated = { ...prev };
    updated.delivery_config.discounts_and_waivers.cart_value_discounts[index].benefit.max_km_covered =
      parseFloat(value) || 0;
    return updated;
  });
};



const handleAddCartValueTier = () => {
  setRestaurantConfig(prev => {
    const updated = { ...prev };

    const newTier = {
      benefit: {
        type: "WAIVE_TIER_COST",
        is_percentage: false,
        max_km_covered: ""
      },
      rule_id: "",
      marketing_text: "",
      min_cart_value: ""
    };

    updated.delivery_config.discounts_and_waivers.cart_value_discounts = [
      ...updated.delivery_config.discounts_and_waivers.cart_value_discounts,
      newTier
    ];

    return updated;
  });
};



const handleDeleteCartValueTier = (index) => {
  setRestaurantConfig(prev => {
    const updated = { ...prev };

    updated.delivery_config.discounts_and_waivers.cart_value_discounts =
      updated.delivery_config.discounts_and_waivers.cart_value_discounts.filter(
        (_, i) => i !== index
      );

    return updated;
  });
};



// -----------------------------
// ROUND TYPE HELPER TEXT
// -----------------------------
const getIncrementHelperText = () => {
  const exampleValue = 2.2;

  if (restaurantConfig?.round_off_config?.method === "NONE") {
    return "No rounding will be applied. The original value will be used as entered.";
  }

  if (restaurantConfig?.round_off_config?.method === "UPWARD") {
    return `The number will always be rounded UP to the next increment selected. 
    For example, if the increment is ${increment} and the value is ${exampleValue}, 
    it will be rounded to ${(Math.ceil(exampleValue / increment) * increment).toFixed(decimalPoints)}.`;
  }

  if (restaurantConfig?.round_off_config?.method === "DOWNWARD") {
    return `The number will always be rounded DOWN to the previous increment selected. 
    For example, if the increment is ${increment} and the value is ${exampleValue}, 
    it will be rounded to ${(Math.floor(exampleValue / increment) * increment).toFixed(decimalPoints)}.`;
  }

  return `The number will be rounded to the nearest increment selected. 
  For example, if the increment is ${increment} and the value is ${exampleValue}, 
  it will be rounded to ${(Math.round(exampleValue / increment) * increment).toFixed(decimalPoints)}.`;
};



  return (


  <div className={sidebar ? 'taskMain' : 'cx-active taskMain'} id="cx-main">
      <div className="role-content">
        <div className="sub-header-role">
          <h6 className="mt-2">Kitchen Management</h6>
          {permissions && permissions["View Inventory Management"] && (
            <StoreSelector
              options={Array.isArray(storesList) ? storesList.map(store => ({
                value: store.value,
                label: store.label,
              })) : []}
              value={selectedStoreID}
              onChange={(value) => {
                setSelectedStoreID(value);
                localStorage.setItem("selectedStoreId", value);
              }}
            />
          )}
        </div>

        { !selectedStoreID ? (<div className='text-center mt-4' >

         <h6>  Please select restaurant first </h6>
           </div>
           ) :


          loading  ? <Loader /> : (

          

        <div className="rc-main-wrapper">
          <header className="rc-page-header">
            <div className="rc-title-block">
              <h1 className="rc-page-title">Configuration:{' '} {filterRestaurantName(resId, storesList )}</h1>
              <p className="rc-page-subtitle">Manage delivery zones, fees, and payment gateways.</p>
            </div>
            <div className="rc-action-buttons">
              <button className="rc-btn-primary" onClick={handleSave} disabled={postLoading}> {postLoading ? <Spinner size='md'/> : "Save Changes" } </button>
            </div>
          </header>

          <div className="rc-body-layout">
            {/* Left Sidebar */}
            <aside className="rc-sidebar-panel">
              <section className="rc-general-rules-box">
                <h3 className="rc-section-heading">General Rules</h3>
                <div className="rc-input-field">
                  <label>MAX DELIVERY RANGE (KM)</label>
                  <input
                    type="number"
                    value={restaurantConfig.delivery_range_km}
                    onChange={(e) => handleInputChange('delivery_range_km', e.target.value)}
                  />
                  <span className="rc-unit-label">km</span>
                </div>
                <div className="rc-input-field">
                  <label>MIN ORDER AMOUNT</label>
                  <input
                    type="number"
                    value={restaurantConfig.minimum_order_amount}
                    onChange={(e) => handleInputChange('minimum_order_amount', e.target.value)}
                  />
                </div>
                <div className="rc-input-field">
                  <label>CANCELLATION WINDOW</label>
                  <input
                    type="number"
                    value={restaurantConfig.order_cancelation_window_minutes}
                    onChange={(e) => handleInputChange('order_cancelation_window_minutes', e.target.value)}
                  />
                  <span className="rc-unit-label">min</span>
                </div>
              </section>

              <section className="rc-payment-methods-box">
                <h3 className="rc-section-heading">Payment Methods</h3>
                {(Array.isArray(restaurantConfig.payment_config) && restaurantConfig.payment_config.length > 0) && restaurantConfig.payment_config.map((pay, idx) => (
                  <div key={idx} className="rc-payment-row">
                    <span>{pay.type}</span>
                    <div className="rc-checkbox-group">
                      <label>
                        <input
                          type="checkbox"
                          checked={pay.cod}
                          onChange={(e) => handlePaymentChange(idx, 'cod', e.target.checked)}
                        /> COD
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={pay.online}
                          onChange={(e) => handlePaymentChange(idx, 'online', e.target.checked)}
                        /> Online
                      </label>
                    </div>
                  </div>
                ))}
              </section>

              <section className="rc-payment-methods-box">
                <h3 className="rc-section-heading">Packing Charges</h3>
                <div className="rc-setting-row">
                  <label className="rc-setting-label">Enable Packing Fee</label>
                  <div className="rc-setting-control">
                    <label className="rc-toggle-switch">
                      <input
                        type="checkbox"
                        checked={restaurantConfig?.packing_config?.enabled}
                        onChange={(e) => handleNestedChange(['packing_config', 'enabled'], e.target.checked)}
                      />
                      <span className="rc-toggle-slider"></span>
                    </label>
                  </div>
                </div>
                <div className="rc-setting-row">
                  <label className="rc-setting-label">Charge Amount (₹)</label>
                  <div className="rc-setting-control">
                    <input
                      type="number"
                      value={restaurantConfig?.packing_config?.package_charges}
                      onChange={(e) => handleNestedChange(['packing_config', 'package_charges'], e.target.value)}
                      className="rc-amount-input"
                      placeholder="0"
                    />
                  </div>
                </div>
                <div className="rc-setting-row">
                  <label className="rc-setting-label">Free Above (₹)</label>
                  <div className="rc-setting-control">
                    <input
                      type="number"
                      value={restaurantConfig.packing_config.package_exemption_price}
                      onChange={(e) => handleNestedChange(['packing_config', 'package_exemption_price'], e.target.value)}
                      className="rc-amount-input"
                      placeholder="e.g. 499"
                    />
                  </div>
                </div>
              </section>


              {/* //////////Round off */}

{/* -----------------------------
     ROUND OFF OPTIONS UI
------------------------------ */}
<div
  style={{
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    // marginBottom: "24px",
    border: "1px solid #e0e0e0",
  }}
>
  <h3 style={{ marginBottom: "16px", fontWeight: 600 }}>
    Round-Off Options
  </h3>

  {/* ROUND TYPE */}
  <div style={{ marginBottom: "16px" }}>
    <label style={{ display: "block", marginBottom: "8px" }}>
      Round off options for billing
    </label>

    <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
      {[
        { label: "Normal", value: "NORMAL" },
        { label: "Round Off Up", value: "UPWARD" },
        { label: "Round Off Down", value: "DOWNWARD" },
        { label: "None", value: "NONE" },
      ].map((opt) => (
        <label
          key={opt.value}
          style={{ display: "flex", alignItems: "center", gap: "6px" }}
        >
          <input
            type="radio"
            name="roundType"
            value={opt.value}
            // checked={roundType === opt.value}
            checked={restaurantConfig?.round_off_config?.method === opt.value}
            // onChange={(e) => setRoundType(e.target.value)}
            onChange={(e) => handleNestedChange(['round_off_config', 'method'], e.target.value)}
          />
          {opt.label}
        </label>
      ))}
    </div>
  </div>

  {/* INCREMENT */}

  <div style={{ marginBottom: "16px" }}>
    <label style={{ display: "block", marginBottom: "8px" }}>
      Round the number to increments of
    </label>

    <select
      value={restaurantConfig?.round_off_config?.increment}
        onChange={(e) => handleNestedChange(['round_off_config', 'increment'], e.target.value)}
      style={{
        width: "250px",
        padding: "8px",
        borderRadius: "5px",
        border: "1px solid #ccc",
      }}
    >
      <option value=''>Select...</option>
      <option value={1}>1 (Default)</option>
      <option value={0.5}>0.5</option>
      <option value={0.25}>0.25</option>
      <option value={0.1}>0.1</option>
    </select>

     {/* Helper text */}
<div
  style={{
    marginTop: "2px",
    fontSize: "13px",
    color: "#666",
    maxWidth: "520px",
  }}
>
  {getIncrementHelperText()}
</div>
  </div>

 

  {/* DECIMAL POINTS */}
  <div style={{ marginBottom: "16px" }}>
    <label style={{ display: "block", marginBottom: "8px" }}>
      Select decimal points for invoice calculation and menu price input
    </label>

    <select
      // value={decimalPoints}
      // onChange={(e) =>
      //   setDecimalPoints(parseInt(e.target.value, 10))
      // }
          value={restaurantConfig?.round_off_config?.precision}
        onChange={(e) => handleNestedChange(['round_off_config', 'precision'], parseInt(e.target.value, 10))}
      
      style={{
        width: "250px",
        padding: "8px",
        borderRadius: "5px",
        border: "1px solid #ccc",
      }}
    >
        <option  value=''>
          Select...
        </option>
      {[0, 1, 2, 3, 4].map((num) => (
        <option key={num} value={num}>
          {num}
        </option>
      ))}
    </select>

    {/* Helper text */}
    <div
      style={{
        marginTop: "2px",
        fontSize: "13px",
        color: "#666",
        maxWidth: "520px",
      }}
    >
      The rounding calculation related to the invoice will be based on the
      number selected in the dropdown. For example, if <b>1</b> is selected,
      <b> 0.9277</b> would be rounded to <b>1.0</b>.
    </div>


  </div>

   
  

  {/* PREVIEW */}
  <div
    style={{
      padding: "12px",
      background: "#f9fafb",
      borderRadius: "6px",
      border: "1px solid #ddd",
      width: "fit-content",
    }}
  >
    <strong>Preview</strong>
    <div>Sample Value: {sampleValue}</div>
    <div>Rounded Value: {roundedValue}</div>
  </div>
</div>




  <section className="rc-payment-methods-box">
                {/* <h3 className="rc-section-heading">Packing Charges</h3> */}
                <div className="rc-setting-row pt-0">
                  <label className="rc-setting-label">Auto Accept Order</label>
                  <div className="rc-setting-control">
                    <label className="rc-toggle-switch">
                      <input
                        type="checkbox"
                        checked={restaurantConfig?.auto_accept}
                        onChange={(e) => handleNestedChange(['auto_accept'], e.target.checked)}
                      />
                      <span className="rc-toggle-slider"></span>
                    </label>
                  </div>
                </div>
                </section>

            </aside>

            {/* Right Main Panel */}
            <main className="rc-content-area">
              {/* Distance Tiers Pricing */}
              <section className="rc-card">
                <div className="rc-card-header">
                  <h3>DISTANCE TIERS PRICING</h3>
                  <button className="rc-add-btn" onClick={handleAddTier}>+ Add Tier</button>
                </div>
                <table className="rc-tiers-table-new">
                  <thead>
                    <tr>
                      <th>Label</th>
                      <th>Range (KM)</th>
                      <th>Fee (₹)</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {(Array.isArray(restaurantConfig.delivery_config.base_components.distance_logic.tiers) && restaurantConfig.delivery_config.base_components.distance_logic.tiers.length > 0)  && restaurantConfig.delivery_config.base_components.distance_logic.tiers.map((tier, idx) => (
                      <tr key={idx}>
                        {/* <td>{tier.label}</td> */}
                        <td>
  <input
    type="text"
    value={tier.label}
    onChange={(e) => handleDistanceTierChange(idx, 'label', e.target.value)}
    className="rc-input-small"
    style={{ width: '90%' }}
  />
</td>
                        <td>
  <input
    type="number"
    value={tier.min_km}
    onChange={(e) => handleDistanceTierChange(idx, 'min_km', e.target.value)}
    className="rc-input-small"
    style={{ width: '30%', marginRight: '2%' }}
  />
  - {' '}
  <input
    type="number"
    value={tier.max_km}
    onChange={(e) => handleDistanceTierChange(idx, 'max_km', e.target.value)}
    className="rc-input-small"
    style={{ width: '30%' }}
  />
</td>
                        <td>
                          <input
                            type="number"
                            value={tier.flat_fee}
                            onChange={(e) => handleDistanceTierChange(idx, 'flat_fee', e.target.value)}
                            className="rc-input-small"
                          />
                        </td>
                        <td>
                <button className="rc-delete-btn" aria-label="Delete tier"  onClick={() => handleOpenDeleteModal(idx, 'tier')}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 6h18"></path>
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                      </svg>
                    </button>
                        </td>
                      </tr>
                    ))}
                 
                     
                  
                  </tbody>
                </table>
                 <FallbackLogicBox
  restaurantConfig={restaurantConfig}
  setRestaurantConfig={setRestaurantConfig}
/>
              </section>


{/* /////////////////////////////////////////////////////////////////////////////////////////////////// */}
               {/* ===== ACTIVE SURCHARGES ===== */}
        <section className="rc-card">
          <div className='d-flex justify-content-between align-items-center'>
          <h3 className="rc-section-title">ACTIVE SURCHARGES</h3>
           <div className="rc-surcharge-actions ">
                {/* <button className="rc-add-surcharge-btn-new">+</button> */}
                <button className="rc-add-surcharge-text" style={{marginBottom:'1rem'}} /* onClick={handleAddSurcharge} */ onClick={handleAddSurchargeClick }>Add Surcharge</button>
              </div>
          </div>
          {/* <div className="rc-surcharge-item-new col-6">
            <div className="rc-surcharge-header">
              <div className="rc-surcharge-label">Small Cart Fee</div>
              <label className="rc-toggle-switch">
                <input
                  type="checkbox"
                  checked={surcharges.small_cart.enabled}
                  onChange={() => handleSurchargeToggle('small_cart')}
                />
                <span className="rc-toggle-slider"></span>
              </label>
            </div>
            <div className="rc-surcharge-controls">
              <div className="rc-surcharge-fields">
                <div className="rc-field">
                  <label>THRESHOLD</label>
                  <input
                    type="number"
                    value={surcharges.small_cart.threshold}
                    onChange={(e) => handleSurchargeChange('small_cart', 'threshold', parseFloat(e.target.value))}
                  />
                </div>
                <div className="rc-field">
                  <label>FEE</label>
                  <input
                    type="number"
                    value={surcharges.small_cart.fee_amount}
                    onChange={(e) => handleSurchargeChange('small_cart', 'fee_amount', parseFloat(e.target.value))}
                  />
                </div>
              </div>
             
            </div>
          </div> */}


<div className='row gap-2 d-none'>
            {Object?.entries(surcharges)?.map(([key, item], index) => (
    <div className="rc-surcharge-item-new col-5" key={key}>
      
      <div className="rc-surcharge-header">
        <div className="rc-surcharge-label">
          {item.label || "Untitled Surcharge"}
        </div>

        <label className="rc-toggle-switch">
          <input
            type="checkbox"
            checked={item.enabled}
            onChange={() => handleSurchargeToggle(key)}
          />
          <span className="rc-toggle-slider"></span>
        </label>

        {/* Show delete button ONLY for added (custom) surcharges */}
        {key.startsWith("custom_") && (
          <button 
            className="rc-delete-btn"
            onClick={() => handleDeleteSurcharge(key)}
          >
            Delete
          </button>
        )}
      </div>

      <div className="rc-surcharge-controls">
        <div className="rc-surcharge-fields">

          {/* threshold field (only if exists) */}
          {"threshold" in item && (
            <div className="rc-field">
              <label>THRESHOLD</label>
              <input
                type="number"
                value={item.threshold}
                onChange={(e) => handleSurchargeChange(
                  key, 
                  "threshold", 
                  e.target.value
                )}
              />
            </div>
          )}

          {/* fee field */}
          <div className="rc-field">
            <label>FEE</label>
            <input
              type="number"
              value={item.fee_amount}
              onChange={(e) => handleSurchargeChange(
                key, 
                "fee_amount", 
                e.target.value
              )}
            />
          </div>

        </div>
      </div>

    </div>
  ))}
  </div>


<div className='row gap-2'>
{Object?.entries(surcharges)
  ?.filter(([key]) => surchargeOrder?.indexOf(key) < visibleCount) // show only first N
  ?.sort(
    ([a], [b]) => surchargeOrder.indexOf(a) - surchargeOrder.indexOf(b)
  ) // ensure correct order
  .map(([key, item]) => (
    <div className="rc-surcharge-item-new col-5" key={key}>
      
      <div className="rc-surcharge-header">
        <div className="rc-surcharge-label">
          {item.label || "Untitled Surcharge"}
        </div>

        <label className="rc-toggle-switch">
          <input
            type="checkbox"
            checked={item.enabled}
            onChange={() => handleSurchargeToggle(key)}
          />
          <span className="rc-toggle-slider"></span>
        </label>
      </div>

      <div className="rc-surcharge-controls">
        <div className="rc-surcharge-fields">

          {"threshold" in item && (
            <div className="rc-field">
              <label>THRESHOLD</label>
              <input
                type="number"
                value={item.threshold}
                onChange={(e) => handleSurchargeChange(
                  key,
                  "threshold",
                  e.target.value
                )}
              />
            </div>
          )}

          <div className="rc-field">
            <label>FEE</label>
            <input
              type="number"
              value={item.fee_amount}
              onChange={(e) => handleSurchargeChange(
                key,
                "fee_amount",
                e.target.value
              )}
            />
          </div>

        </div>
      </div>

    </div>
))}

</div>
        </section>


  <section className="rc-card">
<div className="rc-card-header">
            <h3 className="rc-title-with-icon">Delivery Discounts</h3>
             <p className="rc-apply-all-note">Applied to All Surcharges</p>

            </div>

        {/* ===== DELIVERY DISCOUNTS ===== */}
        {/* <section className="rc-card"> */}
          {/* <div className="rc-card-header">
       
         
          </div> */}
          <div className="rc-card rc-happy-hours-wrapper">
            <div className="rc-happy-hours-label">
              <span className="rc-discount-type">Happy Hours (Time Based)</span>
            </div>
            <div className="rc-time-slots-row">
              {/* Render happy hours dynamically if available */}
              {discounts_and_waivers.happy_hours.map((hour, idx) => (
            
                <div className="rc-time-slot-card" key={idx}>
                  <div className="rc-time-slot-header">
                    <strong>{hour.rule_id}</strong>
                 {/* DELETE BUTTON  taleeb-button*/}
      <button
        className="rc-delete-btn"
        onClick={() => handleOpenDeleteModal(idx, 'happy')}
      >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 6h18"></path>
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                      </svg>
      </button>
                  </div>
                  {/* <div className="rc-time">{hour.start_time} - {hour.end_time}</div>
                  <div className="rc-badge">{hour.display_message}</div> */}



    {/* INLINE TIME INPUTS */}
    <div className="rc-time-inline">

      {/* START TIME */}
      <input
        type="time"
        className="rc-time-input"
        value={hour.start_time}
        style={{padding: '2px 8px'}}
        onChange={(e) =>
          handleNestedChange(
            [
              'delivery_config',
              'discounts_and_waivers',
              'happy_hours',
              idx,
              'start_time'
            ],
            e.target.value
          )
        }
      />

      <span className="rc-time-dash"> - </span>

      {/* END TIME */}
      <input
        type="time"
        className="rc-time-input"
        value={hour.end_time}
          style={{padding: '2px 8px'}}
        onChange={(e) =>
          handleNestedChange(
            [
              'delivery_config',
              'discounts_and_waivers',
              'happy_hours',
              idx,
              'end_time'
            ],
            e.target.value
          )
        }
      />

    </div>

    {hour.display_message && (
      <div className="rc-badge">{hour.display_message}</div>
    )}

                   
                </div>
              ))}
            </div>
          </div>
        {/* </section> */}

        {/* ===== ACQUISITION OFFERS ===== */}
        <section className="rc-card rc-green-card">
          <div className="rc-card-header">
            <h3 className="rc-title-with-icon">Graph Acquisition Offers</h3>
          </div>
          {discounts_and_waivers?.acquisition_offers?.map((offer, idx) => (
            <div className="rc-offer-item-new" key={idx}>
              <div className="rc-offer-content">
                <strong>{offer.rule_id}</strong>
                <div className="rc-offer-desc">{offer.marketing_text?.replace("{{max_cap}}", offer.benefit.max_cap)}</div>
              </div>
              <div className="rc-offer-controls">
                <div className="rc-cap-field">
                  <span className="rc-cap-label">MAX CAP (₹)</span>
                  <input
                    type="number"
                    value={offer.benefit.max_cap}
                    onChange={(e) => handleNestedChange(
                      ['delivery_config', 'discounts_and_waivers', 'acquisition_offers', idx, 'benefit', 'max_cap'],
                      parseFloat(e.target.value)
                    )}
                    className="rc-input-cap"
                  />
                </div>
                <label className="rc-toggle-switch">
                  <input
                    type="checkbox"
                    checked={offer.enabled}
                    onChange={() => handleAcquisitionToggle(idx)}
                  />
                  <span className="rc-toggle-slider"></span>
                </label>
              </div>
            </div>
          ))}
        </section>

        {/* ===== CART VALUE WAIVERS ===== */}
        <section className="rc-card">
          <div className="rc-card-header">
            <h3 className="rc-title-with-icon" >Cart Value Waivers</h3>
                <button className="rc-add-btn" onClick={handleAddCartValueTier}> Add </button>
   
          </div>
          <table className="rc-waiver-table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Is Percentage</th>
                <th>MIN CART (₹)</th>
                <th>BENEFIT</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              {/* {discounts_and_waivers.cart_value_discounts.map((tier, idx) => (
                <tr key={idx}>
                  <td>{tier.benefit.type}</td>
                  <td>{tier.benefit.is_percentage ? 'Yes' : 'No'}</td>
                  <td>
                    <input
                      type="number"
                      value={tier.min_cart_value}
                      onChange={(e) => handleCartValueChange(idx, parseFloat(e.target.value))}
                      className="rc-input-small"
                    />
                  </td>
                  <td>Waive {tier.benefit.max_km_covered} KM</td>
                  <td>
                    <button className="rc-delete-btn" aria-label="Delete tier">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 6h18"></path>
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                      </svg>
                    </button>
                  </td>
                </tr>
              ))} */}


               {discounts_and_waivers.cart_value_discounts.map((tier, idx) => (
    <tr key={idx}>
      
      {/* TYPE DROPDOWN */}
      <td>
        <select
          value={tier.benefit.type}
          onChange={(e) => handleTypeChange(idx, e.target.value)}
          className="rc-input-small"
        >
          <option value="WAIVE_TIER_COST">WAIVE_TIER_COST</option>
          <option value="FULL_TIER_COST">FULL_TIER_COST</option>
        </select>
      </td>

      {/* IS_PERCENTAGE DROPDOWN */}
      <td>
        <select
          value={tier.benefit.is_percentage ? "YES" : "NO"}
          onChange={(e) => handlePercentageChange(idx, e.target.value)}
          className="rc-input-small"
        >
          <option value="YES">Yes</option>
          <option value="NO">No</option>
        </select>
      </td>

      {/* MIN CART VALUE INPUT */}
      <td>
        <input
          type="number"
          value={tier.min_cart_value}
          onChange={(e) => handleCartValueChange(idx, e.target.value)}
          className="rc-input-small"
        />
      </td>

      {/* BENEFIT INPUT */}
      <td>
        <input
          type="number"
          value={tier.benefit.max_km_covered}
          onChange={(e) => handleBenefitChange(idx, e.target.value)}
          className="rc-input-small"
          placeholder="KM"
        />
      </td>

      {/* DELETE BUTTON */}
      <td>
        <button
          className="rc-delete-btn"
          onClick={() => handleOpenDeleteModal(idx, 'waiver')}
          aria-label="Delete tier"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 6h18"></path>
            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
            <line x1="10" y1="11" x2="10" y2="17"></line>
            <line x1="14" y1="11" x2="14" y2="17"></line>
          </svg>
        </button>
      </td>

    </tr>
  ))}
            </tbody>
          </table>
        </section>

{/* //////////Round off */}

{/* -----------------------------
     ROUND OFF OPTIONS UI
------------------------------ */}


   
        </section>
            </main>
          </div>
        </div>

        )
        }
      </div>

      <DeleteModal 
        show={showDeleteModalForTier}
        onClose = {()=>handleCloseDeleteModal('tier')}
        onDelete = {()=> handleDeleteTier(deleteID)}
   
      />
      <DeleteModal 
        show={showDeleteModalForWaiver}
        onClose = {()=>handleCloseDeleteModal('waiver')}
        onDelete = {()=> handleDeleteCartValueTier(deleteID)}
   
      />
      <DeleteModal 
        show={showDeleteModalForHappyHour}
        onClose = {()=>handleCloseDeleteModal('happy')}
        onDelete = {()=> handleDeleteHappyHour(deleteID)}
   
      />
    </div>



  



  );
   

};

export default StoreConfig;


// -----------------------------
// STYLES
// -----------------------------
const styles = {
  card: {
    maxWidth: "600px",
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  },
  title: {
    marginBottom: "20px",
    fontSize: "18px",
    fontWeight: "600",
  },
  section: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "500",
  },
  radioRow: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    cursor: "pointer",
  },
  select: {
    width: "100%",
    padding: "8px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  previewBox: {
    marginTop: "20px",
    padding: "12px",
    background: "#f8f9fa",
    borderRadius: "5px",
    border: "1px solid #ddd",
  },
};